import { Navigate, Outlet, useLocation } from "react-router";

import { isAdminLoggedIn } from "@/client/services/admin";

export const AdminGuard = () => {
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  if (!isAdminLoggedIn()) {
    return <Navigate replace to={`/admin/login?redirect=${encodeURIComponent(redirectTo)}`} />;
  }

  return <Outlet />;
};
